import PropTypes from 'prop-types'
import ShareLink from 'react-facebook-share-link'
import React, { Component } from 'react'
import classnames from 'classnames'
import SvgFacebookLogo from '../Svg/SvgFacebookLogo'
import styles from './styles.css'

class FacebookShare extends Component {
  static propTypes = {
    link: PropTypes.string,
    className: PropTypes.string,
  }

  static defaultProps = {
    link: 'https://friendtivity.se',
    className: '',
  }

  render() {
    return (
      <ShareLink link={this.props.link}>
        {link => (
          <a
            href={link}
            target="_blank"
            className={classnames(this.props.className, styles.button)}
          >
            <SvgFacebookLogo />
            Dela
          </a>
        )}
      </ShareLink>
    )
  }
}

export default FacebookShare



// WEBPACK FOOTER //
// ../source/components/FacebookShare/index.js